import { MessageBar, MessageBarButton, MessageBarType, Stack, StackItem, mergeStyles } from '@fluentui/react';
import React from 'react';
import { getNoIconMessageBarStyles, getMessageBarButtonStyles } from '../styles/vsbUpsellAlertStyles';

interface IUpsellAlertProps {
    classNames: any,
    noIcon?: boolean,
    alertDataAutomationId: string,
    buttonDataAutomationId: string,
    iconName: string,
    ariaLabel: string,
    dismissButtonAriaLabel: string,
    title: string,
    description: string,
    buttonText: string,
    buttonID: string,
    area: string,
    fromnm: string,
    dismissAlert: () => void,
    ctaClicked: () => void,
}

const UpsellAlert = (props: IUpsellAlertProps) => {
    const classNames = props.classNames;
    const messageBarStyles = getNoIconMessageBarStyles();
    const messageBarButtonStyles = getMessageBarButtonStyles();
    return (
        <Stack data-automation-id={props.alertDataAutomationId}>
            <MessageBar
                className={classNames.upsellAlert}
                messageBarType={MessageBarType.info}
                messageBarIconProps={props.noIcon && { iconName: props.iconName }}
                styles={props.noIcon && messageBarStyles}
                aria-label={props.ariaLabel}
                onDismiss={props.dismissAlert}
                dismissButtonAriaLabel={props.dismissButtonAriaLabel}
            >
                <StackItem className={mergeStyles(classNames.upsellAlertMessageTitle)} >
                    {props.title}
                </StackItem>
                <StackItem>
                    {props.description}
                </StackItem>
                <StackItem className={classNames.upsellAlertButtonSection} >
                    <MessageBarButton className={classNames.button + ' ' + classNames.overflowTextElement}
                        styles={messageBarButtonStyles}
                        data-automation-id={props.buttonDataAutomationId}
                        onClick={props.ctaClicked}
                        title={props.buttonText}
                        id={props.buttonID}
                        data-bi-area={props.area}
                        data-bi-formnm={props.fromnm}>
                        {props.buttonText}
                    </MessageBarButton>
                </StackItem>
            </MessageBar>
        </Stack>
    );
};

export default UpsellAlert;
